const { BASE_URL } = require("./client");

const GET_FOUNDERS_CIRCLE_DATA = BASE_URL + "/api/founderscircleform";
const POST_FOUNDERS_CIRCLE_DATA = BASE_URL + "/api/founderscircleform";
const UPDATE_FOUNDERS_CIRCLE_DATA = BASE_URL + "/api/founderscircleform";
const DELETE_FOUNDERS_CIRCLE_DATA = BASE_URL + "/api/founderscircleform";

module.exports = {
  GET_FOUNDERS_CIRCLE_DATA,
  POST_FOUNDERS_CIRCLE_DATA,
  UPDATE_FOUNDERS_CIRCLE_DATA,
  DELETE_FOUNDERS_CIRCLE_DATA,
};
